import { Link } from "react-router-dom";

export default function GrayButton({ btnText, onClick, navigate, textSize }) {
  return (
    <Link
      className={`text-dark-blue ${
        textSize ? textSize : ""
      } py-[8px] max-lg:py-[6px] px-6 bg-dBlue-100 rounded-md transition ease-in-out duration-700 hover:bg-gray-200 font-poppins max-lg:text-sm h-full`}
      onClick={onClick}
      to={navigate}
    >
      {btnText}
    </Link>
  );
}
